import { render, staticRenderFns } from "./comp_AppBarRound-Drawer.vue?vue&type=template&id=527fb2b2&"
import script from "./comp_AppBarRound-Drawer.vue?vue&type=script&lang=js&"
export * from "./comp_AppBarRound-Drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VNavigationDrawer})
